import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
class Icon extends Component {
    render() {
        const { name, pulse, spin, fixedWidth, size, className, ...rest } = this.props;
        let classes = `icon icon-${name}`;
        if (pulse) {
            classes += ' icon--pulse';
        }
        else if (spin) {
            classes += ' icon--spin';
        }
        if (fixedWidth) {
            classes += ' icon--fw';
        }
        if (size) {
            classes += ` icon--${size}`;
        }
        if (className) {
            classes += ' ' + className;
        }
        return _jsx("i", { ...rest, className: classes });
    }
}
Icon.defaultProps = {
    name: '',
    pulse: false,
    spin: false,
    fixedWidth: false,
    className: '',
};
export default Icon;
